/*
  ---------------------------------------------------------------------------
  Tipografia dos cabeçalhos de faixa da capa
  ---------------------------------------------------------------------------

  A escala do DS é `rem` FIXO — não há `clamp()` nem media query nos tokens
  (o `theme/styles/TYPOGRAPHY_GUIDE.md` descrevia o sistema fluido anterior,
  removido em `bd34b046`). Logo, um texto só muda de tamanho entre mobile e
  desktop se a variante de breakpoint estiver escrita aqui. E como
  `scripts/lint-typography.mjs` (que roda com `--strict` no `make lint`) proíbe
  `text-[Nrem]`, parear token + breakpoint é a única forma legítima de fazê-lo.

  TODO cabeçalho de faixa da capa usa esta constante — 18px no celular, 24px a
  partir de `md`. É o corpo de "Acompanhe nossas redes", adotado como padrão
  único a pedido do design.

  O tamanho NÃO acompanha o nível do heading. A capa tem `h2` (faixa de largura
  total, filha direta de `.mpf-secoes`) e `h3` (cartão de coluna, dentro de um
  dos `<h2 class="sr-only">` de `index.tsx`), e os dois recebem o mesmo corpo:
  a hierarquia de leitura de tela continua nas tags, a visual é plana. Não
  reintroduza um segundo tamanho "para acompanhar a tag".

  No mobile, 18px é o teto para cabeçalho: acima disso o título quebra em duas
  linhas ao lado do ícone de 24px — e das abas, nas três faixas que as têm.
*/

/** Cabeçalho de faixa da capa, `h2` ou `h3`. A cor fica no call site. */
export const TITULO_FAIXA = 'text-lg font-semibold md:text-h3';
